
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class FixedRateMasterDialog extends Serenity.EntityDialog<FixedRateMasterRow, any> {
        protected getFormKey() { return FixedRateMasterForm.formKey; }
        protected getIdProperty() { return FixedRateMasterRow.idProperty; }
        protected getLocalTextPrefix() { return FixedRateMasterRow.localTextPrefix; }
        protected getService() { return FixedRateMasterService.baseUrl; }
        protected getDeletePermission() { return FixedRateMasterRow.deletePermission; }
        protected getInsertPermission() { return FixedRateMasterRow.insertPermission; }
        protected getUpdatePermission() { return FixedRateMasterRow.updatePermission; }

        protected form = new FixedRateMasterForm(this.idPrefix);

    }
}